// extracted by mini-css-extract-plugin
export default {"manageStrategies":"strategies_manageStrategies__NwFZ2","wrapper":"strategies_wrapper__p2Tj2","btns":"strategies_btns__RS6k-"};